import { Component, h, Fragment } from '@stencil/core';

@Component({
    tag: 'rtr-short-article-list-skeleton',
    styleUrl: 'style.sass',
    shadow: false,
})

export class RtrShortArticleListSkeleton {
    render() {
        return (
            <Fragment>
                <div class="ArticleListContainer">
                    <rentware-spinner withOverlay={true} />

                    <div class="ArticleImg SkeletonImg" />

                    <div class="ArticleContainerContent">
                        <div class="Title SkeletonTitle" />

                        <div class="UnderTitle SkeletonUnderTitle" />

                        <div class="SkeletonSpacerS" />

                        <div class="Description SkeletonDescription" />

                        <div class="SkeletonSpacerS" />
                        <div class="SkeletonSpacerS" />
                        <div class="SkeletonSpacerS" />
                    </div>

                    <div class="ActionContainer">
                        <div class="PriceContainer SkeletonPrice" />

                        <div class="SkeletonButton" />
                    </div>
                </div>

                <div class="SkeletonSpacerS" />
            </Fragment>
        )
    }
}
